module.exports = __webpack_public_path__ + "static/media/add-circle-outline.519054e4.svg";